<template>
  <div :style="style">{{ initials }}</div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "",
    },
    size: {
      type: Number,
      default: 32,
    },
  },
  data() {
    return {
      seed: 0,
    };
  },
  computed: {
    style() {
      const color = this.getAvatarColor(this.name);
      const textColor = this.getContrastTextColor(color);
      return {
        backgroundColor: color,
        color: textColor,
        width: `${this.size}px`,
        height: `${this.size}px`,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      };
    },

    initials() {
      return this.name
        .split(" ")
        .map((name) => name[0])
        .join("");
    },
  },
  methods: {
    getAvatarColor(str) {
      const colors = [
        "#F44336", // red
        "#FF9800", // orange
        "#00BCD4", // cyan
        "#2196F3", // blue
        "#3F51B5", // indigo
        "#673AB7", // violet
        "#9C27B0", // purple
        "#E91E63", // pink
        "#795548", // brown
      ];
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      const index = Math.abs(hash) % colors.length;
      return colors[index];
    },

    getContrastTextColor(hex) {
      const r = parseInt(hex.substr(1, 2), 16);
      const g = parseInt(hex.substr(3, 2), 16);
      const b = parseInt(hex.substr(5, 2), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance > 0.5 ? "#000000" : "#FFFFFF";
    },
  },
};
</script>
